import QuizStep from './QuizStep'

export default QuizStep
